
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-studies/california-writing-achievement",
      function () {
        return require("private-next-pages/case-studies/california-writing-achievement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-studies/california-writing-achievement"])
      });
    }
  